<div class="common-lateral-panel"
  [ngClass]="{'common-lateral-panel--expand':boxComments.fullScreen && !boxComments.showCommentBox,
    'common-lateral-panel--expand-text-comment':boxComments.fullScreen && boxComments.showCommentBox,
    'common-lateral-panel--no-content':!boxComments.commentList.length && !boxComments.showCommentBox
  }">
  <div class="common-section-title__lp-container">
    <div class="common-section-title__lp-title-icon">
      <i class="lf-icon-chat common-icon__lg"
        [ngClass]="{'common-icon__main': !isLanding}"></i>
      <span class="common-section-title__lp-label-text"
        [afTranslate]="'comments.comments'">_Comentarios</span>
    </div>
    <div class="common-section-title__dp-buttons-container">
      <button
        class="common-button__icon-md-noborder"
        (click)="newComment()"
        [disabled]="boxComments.showCommentBox || userPermissions === 'none' || !(boxComments.taskId || boxComments.conceptObjectId) || boxComments.taskStateNoEditable || (boxComments.conceptObjectId && readOnly)"
        pTooltip="{{'comments.new-comment' | afTranslate}}"
        tooltipPosition="top"
        [tooltipDisabled]="boxComments.showCommentBox || userPermissions === 'none' || !(boxComments.taskId || boxComments.conceptObjectId) || boxComments.taskStateNoEditable">
        <i class="lf-icon-add-round common-icon__md"></i>
      </button>
    </div>
  </div>
  <div class="common-lateral-panel__body gap-[8px]"
    [ngClass]="{'common-lateral-panel__body--no-content':!boxComments.commentList.length && !boxComments.showCommentBox}">
    @if (boxComments.showCommentBox && (userPermissions !== 'none' && (boxComments.taskId || boxComments.conceptObjectId)) && !boxComments.taskStateNoEditable) {
      <div class="common-lateral-panel__body-new-comment">
        <div class="common-lateral-panel__body-new-header">
          <div class="common-lateral-panel__body-new-header-title">
            <div class="common-badge__block-dot-md">
              <div class="common-badge__dot-xs-main-1000"></div>
            </div>
            <p class="common-lateral-panel__body-new-title-text"
            [afTranslate]="'comments.new-comment'">_Nuevo comentario</p>
          </div>
        </div>
        <label for="comment-text-area"
          class="common-lateral-panel__new-comment-block">
          <textarea id="comment-text-area"
            class="common-lateral-panel__new-comment-textarea"
            autocomplete="off"
            [placeholder]="'common.write-here' | afTranslate"
            [(ngModel)]="boxComments.commentText">
          </textarea>
        </label>
        <div class="common-lateral-panel__buttons-container">
          <button class="common-button__text-little-border"
            (click)="closeComment()">
            <span class="common-button__text-little-title"
            [afTranslate]="'common.cancel'">Cancelar</span>
          </button>
          <button class="common-button__text-little"
            (click)="createNewComment(boxComments.commentText)">
            <span class="common-button__text-little-title"
              [afTranslate]="'common.add'">Añadir</span>
          </button>
        </div>
      </div>
    }
    @for (comment of boxComments.commentListFilter | afOrderBy:'creationDate':true | afLimitTo:boxComments.fullScreen?boxComments.commentListFilter.length:1; track $index) {
      <div class="common-lateral-panel__message-container"
        [ngClass]="{'gap-[8px]': comment.edit}">
        <div class="common-lateral-panel__message-container-header">
          <div class="common-lateral-panel__message-container-header-left"
            [ngClass]="{'common-lateral-panel__message-container-header-left--clickable': comment.showOptions && !boxComments.taskStateNoEditable && !(boxComments.conceptObjectId && readOnly)}"
            (click)="editComment(comment)">
            <div class="common-badge__block-dot-md">
              <div class="common-badge__dot-xs-main-1000"></div>
            </div>
            <div class="common-lateral-panel__message-specific-data-block">
              <div class="common-lateral-panel__message-client-container">
                <div class="common-lateral-panel__message-client-content">
                  <p class="common-lateral-panel__message-client-text-strong">{{ comment.author }}</p>
                </div>
              </div>
              <div class="common-lateral-panel__message-client-date">
                <p class="common-lateral-panel__message-client-date-container">
                  <span class="common-lateral-panel__message-client-date-text">{{ comment.creationDate | convertDate: 'without-time' }}</span>
                </p>
                <p class="common-lateral-panel__message-client-date-container">
                  <span class="common-lateral-panel__message-client-date-text">{{ comment.creationDate | convertDate: 'only-time' }}</span>
                </p>
              </div>
            </div>
          </div>
          @if (comment.showOptions && !boxComments.taskStateNoEditable && !(boxComments.conceptObjectId && readOnly)) {
            <button class="common-lateral-panel__button-action"
              pTooltip="{{'common.remove' | afTranslate}}"
              tooltipPosition="top"
              (click)="deleteComment(comment)">
              <i class="lf-icon-trash common-icon__md"></i>
            </button>
          }
        </div>
        @if (comment.edit) {
          <label for="comment-text-area"
            class="common-lateral-panel__new-comment-block">
            <textarea id="comment-text-area"
              class="common-lateral-panel__new-comment-textarea"
              autocomplete="off"
              pAutoFocus
              [autofocus]="comment.edit"
              [(ngModel)]="comment.commentTextarea">
            </textarea>
          </label>
          <div class="common-lateral-panel__buttons-container">
            <button class="common-button__text-little-border"
              (click)="closeComment(comment)">
              <span class="common-button__text-little-title"
                [afTranslate]="'common.cancel'">Cancelar</span>
            </button>
            <button class="common-button__text-little"
              (click)="changeComment(comment)">
              <span class="common-button__text-little-title"
                [afTranslate]="'common.save'">Guardar</span>
            </button>
          </div>
        }@else {
          <div class="common-lateral-panel__message-text-block">
            <div class="common-lateral-panel__message-inner-text"
              [innerHTML]="comment.commentText"></div>
          </div>
        }
      </div>
    }@empty {
      @if (!boxComments.showCommentBox) {
        <p class="common-lateral-panel__no-content"
          [afTranslate]="'comments.no-comments'">_No hay comentarios</p>
      }
    }
  </div>
  @if(!(!boxComments.fullScreen && boxComments.showCommentBox) && boxComments.commentListFilter.length){
    <div class="common-lateral-panel__expand-block">
      <div class="common-lateral-panel__expand-total-block">
        <p class="common-lateral-panel__expand-total-text">
          <span [afTranslate]="'common.total'">_Total</span>
          <span class="pr-1">:</span>
          <span>{{boxComments.commentListFilter?.length}}</span>
        </p>
      </div>
      <button class="common-button__expand-toned"
        (click)="boxComments.fullScreen = !boxComments.fullScreen">
        <i class=" common-icon__md"
          [ngClass]="boxComments.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
        <span class="common-button__expand-label-text"
          [afTranslate]="boxComments.fullScreen?'common.collapse':'common.expand'"></span>
      </button>
    </div>
  }
</div>
